import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { UgcImageGalleryListingComponent } from '../ugc-image-gallery-listing.component';
import { NUgcImageGallery } from '../ugc-image-gallery.namespace';
import { UgcImageGalleryCmsComponent } from './ugc-image-gallery-cms.component';
@Component({
    selector: 'ugc-image-gallery-listing-cms',
    template: '<ugc-image-gallery-listing [content]="component" />',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [UgcImageGalleryListingComponent]
})
@ICmsComponent<UgcImageGalleryListingCmsComponent>({
    id: 'ugc-image-gallery-listing',
    name: 'User Generated Content Image Gallery Listing Layout',
    tags: ['ugc', 'gallery', 'listing'],
    fields: [
        ...NUgcImageGallery.FIELDS.slice(0, 1),
        ...NUgcImageGallery.FIELDS.slice(3,4),
        NUgcImageGallery.UGC_CATEGORY_FIELD,
        NUgcImageGallery.UGC_ROOM_FIELD,
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.number,
            title: 'Initial Steps loaded',
            key: 'initialStepsVisible',
            description: 'Steps showing up at page load'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.number,
            title: 'Step Size',
            key: 'infScrollStep',
            description: 'Number of items loaded per infinite scroll step.'
        },
        <NICmsContentField.IField>{
            key: 'hideFilters',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Hide Filters',
            default: false
        },
        <NICmsContentField.IField>{
            key: 'hideViewMoreInfo',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Hide "View More" Info',
            default: false
        },
        <NICmsContentField.IField>{
            key: 'showShopTheLook',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Show Shop The Look',
            default: false
        },
        NICmsContentComponent.backgroundField
    ]
})
export class UgcImageGalleryListingCmsComponent extends UgcImageGalleryCmsComponent {
    @ICmsContent({
        type: 'component'
    })
    override component?: NUgcImageGallery.IListingData;


    @ViewChild(UgcImageGalleryListingComponent)
    ugcImageGalleryListingComponent?: UgcImageGalleryListingComponent;

    override detectChanges(): void {
        super.detectChanges();
        this.ugcImageGalleryListingComponent?.ngOnChanges();
    }

}
